import featureIcon1 from '../../images/f4.png';
import featureIcon2 from '../../images/f6.png';
import featureIcon3 from '../../images/f1.png';
import featureIcon4 from '../../images/f2.png';

export const features = [
  { icon: featureIcon1, title: 'Virtual first consultation', bgColor: '#c8def4' },
  { icon: featureIcon2, title: 'Expert second opinion', bgColor: '#f8e1be' },
  { icon: featureIcon3, title: 'Affordable treatment guidance', bgColor: '#cae9f4' },
  { icon: featureIcon4, title: 'Personalized care plan', bgColor: '#e9caf9' }
];

export const testimonials = [
  {
    text: "Dr. Darahasa's online consultation was incredibly helpful. I received clear explanations and effective solutions for my dental issues without needing to visit the clinic. Very satisfied with the outcome!",
    author: "Srinivas"
  },
  {
    text: "The online consultation with Dr. Darahasa was excellent. I got detailed advice and quick responses to my dental concerns, all from the comfort of my home. Highly recommend!",
    author: "Sai Sathvik"
  },
  {
    text: "I was unsure about my dental issue and reached out to Dr. Darahasa. The consultation was informative, and I left feeling much more confident about my dental health. Thank you!",
    author: "Namratha"
  },
  {
    text: "Highly satisfied with the service! Dr. Darahasa was attentive, and the advice I received was spot-on. It's a game-changer to have access to such quality care online.",
    author: "Srinivas"
  }
];